// @ts-nocheck
import * as types from 'appRedux/actions/dashboard';

const widgets = [
  'basicInfo',
  'contractValue',
  'projectStatus',
  'budgetStatus',
  'budgetTotal',
  // 'plantDamage',
  'cashFlow',
  'costs',
  'revenue',
  'variations',
  // 'labour',
  // 'table',
];

function getWidgetHeight(widgetName) {
  if (
    widgetName === 'cashFlow' ||
    widgetName === 'costs' ||
    widgetName === 'revenue' ||
    widgetName === 'variations' ||
    widgetName === 'basicInfo'
  ) {
    return 3;
  }

  if (widgetName === 'budgetTotal') {
    return 2;
  }

  if (widgetName === 'budgetStatus') return 2;
  if (widgetName === 'projectStatus') return 3;

  return 1;
}

const initialState = {
  loader: false,
  showWidgetsModal: false,

  filterModal: {
    show: false,
    title: '',
  },
  userPreferenceId: null,
  layout: widgets.map((widgetName, i) => ({
    x: (i * 6) % 12,
    y: 0,
    w: 6,
    h: getWidgetHeight(widgetName),
    minW: 6,
    minH:
      widgetName === 'cashFlow' ||
      widgetName === 'costs' ||
      widgetName === 'revenue' ||
      widgetName === 'variations'
        ? 2
        : getWidgetHeight(widgetName),
    i: widgetName,
  })),
  widgets: {
    basicInfo: {
      added: true,
      fields: [
        { label: 'Project Name', value: 'projectname', checked: true },
        { label: 'Project Id', value: 'projectId', checked: true },
        { label: 'Client Name', value: 'clientName', checked: true },
        { label: 'Job Address', value: 'jobAddress', checked: true },
        { label: 'Start Date', value: 'startDate', checked: true },
        { label: 'End Date', value: 'endDate', checked: true },
        { label: 'Project Manager', value: 'projectManager', checked: true },
        {
          label: 'Construction Manager',
          value: 'constructionManager',
          checked: true,
        },
        { label: 'Risk Factor', value: 'riskFactor', checked: true },
      ],
    },
    contractValue: {
      added: true,
    },
    projectStatus: { added: true },
    budgetStatus: { added: true },
    budgetTotal: { added: true },
    // plantDamage: { added: true },
    // table: { added: true },
    cashFlow: {
      added: true,
      chart: 'line',
      fields: [
        {
          label: 'Construction Budget Cost',
          value: 'construction_budget_cost',
          color: '#233759',
          checked: true,
        },
        {
          label: 'Construction Budget Claim',
          value: 'construction_budget_claim',
          color: '#f27921',
          checked: true,
        },
        {
          label: 'Tracked Cost',
          value: 'tracked_cost',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Approved Claim',
          value: 'claim_amount',
          color: '#60911d',
          checked: true,
        },
      ],
    },
    revenue: {
      added: true,
      chart: 'bar',
      fields: [
        {
          label: 'Construction Budget Claim',
          value: 'construction_budget_claim',
          color: '#233759',
          checked: true,
        },
        {
          label: 'Submitted Contract Claim',
          value: 'submitted_contract_claim',
          stackId: 'a',
          color: '#f27921',
          checked: true,
        },
        {
          label: 'Submitted Variation Claim',
          value: 'submitted_variation_claim',
          stackId: 'a',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Approved Contract Claim',
          value: 'approved_contract_claim',
          stackId: 'b',
          color: '#60911d',
          checked: true,
        },
        {
          label: 'Approved Variation Claim',
          value: 'approved_variation_claim',
          stackId: 'b',
          color: '#8dc641',
          checked: true,
        },
      ],
    },
    costs: {
      added: true,
      chart: 'bar',
      fields: [
        {
          label: 'Construction Budget Cost',
          value: 'construction_budget_cost',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Actual Contract Cost',
          value: 'actual_contract_cost',
          stackId: 'a',
          color: '#8dc641',
          checked: true,
        },
        {
          label: 'Actual Variation Cost',
          value: 'actual_variation_cost',
          stackId: 'a',
          color: '#60911d',
          checked: true,
        },
      ],
    },
    variations: {
      added: true,
      chart: 'line',
      fields: [
        {
          label: 'Submitted Variation Value',
          value: 'submitted_variation_value',
          color: '#fbad33',
          checked: true,
        },
        {
          label: 'Approved Variation Value',
          value: 'approved_variation_value',
          color: '#60911d',
          checked: true,
        },
        {
          label: 'Not Proceeded Variation Value',
          value: 'not_proceeded_variation_value',
          color: '#8dc641',
          checked: true,
        },
      ],
    },
    // labour: {
    //   added: true,
    //   chart: 'line',
    //   fields: [
    //     {
    //       label: 'Forecast Units',
    //       value: 'forecast_units',
    //       color: '#fbad33',
    //       checked: true,
    //     },
    //     {
    //       label: 'Actual Units',
    //       value: 'actual_units',
    //       color: '#60911d',
    //       checked: true,
    //     },
    //   ],
    // },
  },
  filter: {
    startDate: null,
    endDate: null,
  },
  report: {
    basicInfo: {},
    projectStatus: {},
    contractValue: {},
    budgetStatus: [],
    budgetTotal: [],
    cashFlow: [],
    costs: [],
    variations: [],
    // table: [],
    revenue: [],
    // labour: [],
  },
};

function dashboardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.ADD_WIDGET:
      return addWidget(state, action);

    case types.REMOVE_WIDGET:
      return removeWidget(state, action);

    case types.CHANGE_LAYOUT:
      return {
        ...state,
        layout: action.payload.layout,
      };

    case types.OPEN_WIDGETS_MODAL:
      return {
        ...state,
        showWidgetsModal: true,
      };

    case types.CLOSE_WIDGETS_MODAL:
      return {
        ...state,
        showWidgetsModal: false,
      };

    case types.OPEN_FILTER_MODAL:
      return {
        ...state,
        filterModal: {
          show: true,
          title: action.payload.title,
        },
      };

    case types.CLOSE_FILTER_MODAL:
      return {
        ...state,
        filterModal: {
          show: false,
          title: '',
        },
      };

    case types.SELECT_CHART:
      const { widget, chart } = action.payload;
      return {
        ...state,
        widgets: {
          ...state.widgets,
          [widget]: {
            ...state.widgets[widget],
            chart,
          },
        },
      };

    case types.SELECT_WIDGET_FIELD:
      return selectWidgetField(state, action);

    case types.FILTER_WIDGET_BY_DATE:
      return {
        ...state,
        filter: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
      };

    case types.SET_PROJECT_BASIC_INFO:
      return {
        ...state,
        report: {
          ...state.report,
          basicInfo: action.payload[0],
        },
      };

    case types.SET_PROJECT_STATUS:
      return {
        ...state,
        report: {
          ...state.report,
          projectStatus: action.payload.data,
        },
      };

    case types.SET_BUDGET_STATUS:
      return {
        ...state,
        report: {
          ...state.report,
          budgetStatus: action.payload,
        },
      };

    case types.SET_BUDGET_TOTAL:
      return {
        ...state,
        report: {
          ...state.report,
          budgetTotal: action.payload,
        },
      };

    case types.SET_CONTRACT_VALUE:
      return {
        ...state,
        report: {
          ...state.report,
          contractValue: action.payload.data,
        },
      };

    case types.SET_PROJECT_COST:
      return {
        ...state,
        report: {
          ...state.report,
          costs: action.payload.data,
        },
      };

    case types.SET_PROJECT_VARIATIONS:
      return {
        ...state,
        report: {
          ...state.report,
          variations: action.payload.data,
        },
      };

    case types.SET_PROJECT_CASH_FLOW:
      return {
        ...state,
        report: {
          ...state.report,
          cashFlow: action.payload.data,
        },
      };

    case types.SET_PROJECT_REVENUE:
      return {
        ...state,
        report: {
          ...state.report,
          revenue: action.payload.data,
        },
      };

    case types.SET_USER_PREFERENCE:
      return setUserPreference(state, action);

    case types.GET_DASHBOARD_REPORTS_REQUEST:
      return {
        ...state,
        loader: true,
        userPreferenceId: null,
      };

    case types.GET_DASHBOARD_REPORTS_SUCCESS:
      return {
        ...state,
        loader: false,
      };

    default: {
      return state;
    }
  }
}

const addWidget = (state, action) => {
  const {
    payload: { widgetName },
  } = action;
  const maxValY = Math.max(...state.layout.map((item) => item.y), 0);
  return {
    ...state,
    layout: state.layout.concat({
      x: (state.layout.length * 6) % 12,
      y: maxValY + 1,
      w: 6,
      h: getWidgetHeight(widgetName),
      minW: 6,
      minH:
        widgetName === 'cashFlow' ||
        widgetName === 'costs' ||
        widgetName === 'revenue' ||
        widgetName === 'variations'
          ? 2
          : getWidgetHeight(widgetName),
      i: widgetName,
    }),
    widgets: {
      ...state.widgets,
      [widgetName]: {
        ...state.widgets[widgetName],
        added: true,
      },
    },
  };
};

const removeWidget = (state, action) => {
  const {
    payload: { widgetName },
  } = action;
  return {
    ...state,
    layout: state.layout.filter((item) => item.i !== widgetName),
    widgets: {
      ...state.widgets,

      [widgetName]: {
        ...state.widgets[widgetName],
        added: false,
      },
    },
  };
};

const selectWidgetField = (state, action) => {
  const {
    payload: { widget, fields },
  } = action;

  return {
    ...state,

    widgets: {
      ...state.widgets,

      [widget]: {
        ...state.widgets[widget],
        fields: state.widgets[widget].fields.map((field) =>
          fields.includes(field.value)
            ? {
                ...field,
                checked: true,
              }
            : {
                ...field,
                checked: false,
              },
        ),
      },
    },
  };
};

const setUserPreference = (state, action) => {
  if (Object.keys(action.payload).length > 0) {
    const {
      payload: { id, layout, widgets },
    } = action;

    if (layout && widgets) {
      return {
        ...state,
        layout,
        widgets,
        userPreferenceId: id,
      };
    }
  }
  return state;
};

export default dashboardReducer;
